import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {FilesRoutePayload} from '../page-data/payloads/files'
import {pullRequestApplyAutomatedSuggestionPath} from '@github-ui/paths'

/**
 * Applies automated suggestion for an automated review comment
 */
export function useApplyAutomatedSuggestionMutation(automatedCommentId: string, path?: string) {
  const payload = useRoutePayload<FilesRoutePayload>()

  let apiUrl: string
  if (payload?.pullRequest) {
    const {
      pullRequest: {pathName: basePath},
    } = payload
    apiUrl = pullRequestApplyAutomatedSuggestionPath({basePath, automatedReviewCommentId: automatedCommentId})
  } else if (typeof path !== 'undefined') {
    apiUrl = path
  } else {
    throw new Error('apiUrl could not be determined: both payload.pullRequest and path are undefined')
  }

  return useMutation({
    mutationFn: async ({message}: {message: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          message,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: () => {
      // TODO(@aliceclv): double check that it's the intended behavior
      // We want to reload so we get the updated diff
      ssrSafeWindow?.location.reload()
    },
  })
}
